import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { SpPaymentsPage } from '@/components/SpPayments/SpPaymentsPage'
import { listSearchSchema, withoutListDefaults } from '@/components/common/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the shared list page. */
export const Route = createFileRoute('/_app/operations/sp-payments/')({
  validateSearch: listSearchSchema,
  component: SpPaymentsRoute,
})

function SpPaymentsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SpPaymentsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
